import { PropsWithChildren } from 'react';
import { LinkProps, default as NextLink } from 'next/link';
import { logEventAsArray, TAnalyticArgs } from '@/analytics';
import { classnames } from '@/utils/classnames';

export interface ILinkProps
  extends PropsWithChildren,
    Pick<TDivProps, 'id' | 'className' | 'onClick'>,
    Pick<TAnchorProps, 'target'> {
  href: LinkProps['href'];
  analytics?: TAnalyticArgs;
  classNames?: {
    root?: string;
    innerBlock?: string;
  };
}

export const Link = ({
  id,
  href,
  onClick,
  analytics,
  children,
  className,
  target,
  classNames,
}: ILinkProps) => {
  const handleClick: TDivProps['onClick'] = (...args) => {
    logEventAsArray(analytics);
    if (onClick) onClick(...args);
  };

  return (
    <NextLink
      className={classNames?.root}
      href={href}
      target={target}
      {...(target === '_blank' && { rel: 'noopener noreferrer' })}
    >
      <div
        className={classnames(className, classNames?.innerBlock)}
        id={id}
        onClick={handleClick}
      >
        {children}
      </div>
    </NextLink>
  );
};
